import { showAddBillingDataModal } from '@components/features/modals/billing-data/AddBillingDataModal';
import { CvViewLimitStatusCode, showCvViewLimitExceededModal } from '@root/src/components/features/modals/employer/CvViewLimitExceeded';
import { showPremiumModal } from '@components/features/modals/premium/PremiumModal';
import { bjToast } from '@components/common';
import { NoSymbolIcon } from '@heroicons/react/24/solid';
import { ApiResumeDetail } from '@type/v1-api-types';

type HandleResumeErrorParams = {
  response: ApiResumeDetail;
  locale: Locale;
  slug: string;
  jobSlug?: string;
  toastErrorMessage: string;
  onPayPerViewCallback?: () => void;
  onSearchPackActivateCallback?: () => void;
};

export const handleResumeErrorCode = ({
  response,
  locale,
  slug,
  jobSlug,
  toastErrorMessage,
  onPayPerViewCallback,
  onSearchPackActivateCallback,
}: HandleResumeErrorParams) => {
  const code = response?.errors?.[0]?.code;

  switch (code) {
    case 801: {
      const employerData = {} as ApiSchema<'CompanyRead'>;
      showAddBillingDataModal(locale, employerData, () => {
        window.location.href = jobSlug
          ? `/job/${jobSlug}/cv/${slug}`
          : `/cv/${slug}`;
      });
      break;
    }

    case 802:
    case 803:
      showCvViewLimitExceededModal(code as CvViewLimitStatusCode, locale);
      break;

    case 804:
      showPremiumModal(locale, jobSlug ?? '', 804, onPayPerViewCallback, onSearchPackActivateCallback);
      break;

    case 805:
      showPremiumModal(locale, jobSlug ?? '', 805, onPayPerViewCallback, onSearchPackActivateCallback);
      break;

    case 854:
      showPremiumModal(locale, jobSlug ?? '', 805);
      break;

    default:
      bjToast(toastErrorMessage, {
        icon: (
          <NoSymbolIcon className="-mb-px inline-block size-7 text-lg text-error" />
        ),
        className: 'border-l-3 border-error',
      });
      break;
  }
};
